import React from "react";

export type FaqItem = {
  question: string;
  answer: string | React.ReactElement;
};

export const faqItems: FaqItem[] = [
  {
    question: "What happens after I complete my purchase?",
    answer: "Once your payment is confirmed, you'll get immediate access to the product with all features included in your selected plan.",
  },
  {
    question: "Do I need to install anything?",
    answer: "No installation is required. Our products are entirely cloud-based and accessible directly through your browser once you log in.",
  },
  {
    question: "Can I purchase a subscription for someone else?",
    answer: "Yes. When you purchase a subscription, you become the subscription admin. You can assign or share the subscription with other users via the DWSIM Pro usage page.",
  },
  {
    question: "Can I share a DWSIM Pro Hourly subscription with someone else?",
    answer: "Yes. DWSIM Pro Hourly subscriptions can be shared with any user — even outside your organization. Multiple users can access DWSIM Pro simultaneously on their own computers, and each user can track their individual usage.",
  },
  {
    question: "Can I share a DWSIM Pro Team or DWSIM Pro Unlimited subscription?",
    answer: "No. These subscriptions cannot be shared, but you can assign seats to named users within your organization.",
  },
  {
    question: "Can I track how long someone used my DWSIM Pro Hourly subscription?",
    answer: "Yes. As the subscription admin, you can view detailed usage data on your DWSIM Pro usage page. You'll also receive daily and monthly email reports summarizing usage.",
  },
  {
    question: "Can I repurchase the same hourly subscription if I run out of hours?",
    answer: "Yes. You can repurchase the same hourly subscription as often as needed.",
  },
  {
    question: "Are unused subscription hours carried over?",
    answer: "No. Unused hours expire at the end of each billing cycle and do not roll over.",
  },
  {
    question: "Can I upgrade, downgrade, or cancel my subscription?",
    answer: "Yes. You can upgrade or downgrade your plan at any time while your subscription is active. You may cancel any time before renewal through the Customer Billing Portal.",
  },

  {
    question: "What happens at the end of my subscription?",
    answer: "Your subscription will automatically renew based on your selected billing cycle (monthly or annual). You can cancel at any time before renewal in the Customer Billing Portal.",
  },
  {
    question: "Do you send reminders before renewal?",
    answer: "Yes. You'll receive an email reminder 3 days before your subscription renewal date.",
  },
  {
    question: "Can I get a receipt or invoice for each billing period?",
    answer: "Yes. Receipts and invoices can be downloaded from your Customer Billing Portal.",
  },
  {
    question: "Can I get an official quote?",
    answer: "Yes. Send us a message stating the product you're interested in, the name, email and the position of the person for the quote together with your company address. We'll send you a formal quote within 1-2 business days.",
  },  
  {
    question: " Who is a subscription admin?",
    answer: "A subscription admin is the person who has purchased a subscription (purchasing department, a project manager, an engineer/user). This person is responsible for managing the subscription account. This includes updating billing information, adding or removing users (if applicable), and handling renewals or cancellations.",
  },
  {
    question: "Can I get an invoice first and pay afterwards?",
    answer: <span>Yes. You will need to request and accept a quote first.<br />
      We'll email the invoice to you with a secure payment link.<br />
      You will be able to pay online by bank transfer, credit card or any payment method enabled for your country. <br />
      <b>Note:</b> <u>You must specify who should be included on the invoice if it's different to the subscription admin or the end user. </u> 
    </span>
  },
  {
    question: "How DWSIM Private Support works?",
    answer: <span>It is available to both, users of free open source DWSIM as well as users
     of paid DWSIM Pro subscriptions. The add-on product is designed for users who need
      direct, personalized technical and engineering assistance with DWSIM simulations.
       Support is provided through a dedicated hourly package of 5 hours per month. 
       All requests are tracked and receive priority handling. 
       Assistance is delivered via email/support portal. 
       Visit <a href="https://simulate365.com/support-policy/" target="_blank">simulate365.com/support-policy/</a> for more information.</span>
  }
];
